enum IntegrationType {
  SALESFORCE = "Salesforce",
  HUBSPOT = "Hubspot",
  PIPEDRIVE = "Pipedrive",
  CRONO = "Crono",
}

export default IntegrationType;
